export default __webpack_public_path__ + "static/ntx-e569585e9186d516082dec963d7220ef.png";